import { Phone, Mail, Instagram, MapPin, Navigation, MessageSquare } from 'lucide-react';
import { Reveal, SectionHeading } from './Reveal';
import { PHONE, PHONE_HREF, SMS_HREF, EMAIL, INSTAGRAM, INSTAGRAM_HREF, DIRECTIONS_HREF, SERVICE_AREAS } from '../data/content';

const Contact = () => (
  <section id="contact" data-testid="contact-section" className="scroll-mt-24 border-t border-white/5 bg-[#0a0a0a] py-28 lg:py-36">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <SectionHeading eyebrow="Contact" title={<>Let's get you<br /><span className="italic text-gold">on the road.</span></>} />
      <div className="grid gap-16 lg:grid-cols-2">
        <div className="space-y-8">
          <Reveal>
            <a data-testid="contact-phone" href={PHONE_HREF} className="group flex items-center gap-5">
              <span className="flex h-12 w-12 items-center justify-center border border-gold/25 transition-colors duration-300 group-hover:border-gold group-hover:bg-gold/10">
                <Phone className="h-5 w-5 text-gold" strokeWidth={1.25} />
              </span>
              <span>
                <span className="block text-[10px] uppercase tracking-[0.3em] text-white/40">Phone</span>
                <span className="font-display text-2xl text-white transition-colors group-hover:text-gold">{PHONE}</span>
              </span>
            </a>
          </Reveal>
          <Reveal delay={0.08}>
            <a data-testid="contact-email" href={`mailto:${EMAIL}`} className="group flex items-center gap-5">
              <span className="flex h-12 w-12 items-center justify-center border border-gold/25 transition-colors duration-300 group-hover:border-gold group-hover:bg-gold/10">
                <Mail className="h-5 w-5 text-gold" strokeWidth={1.25} />
              </span>
              <span>
                <span className="block text-[10px] uppercase tracking-[0.3em] text-white/40">Email</span>
                <span className="text-lg text-white transition-colors group-hover:text-gold">{EMAIL}</span>
              </span>
            </a>
          </Reveal>
          <Reveal delay={0.16}>
            <a data-testid="contact-instagram" href={INSTAGRAM_HREF} target="_blank" rel="noopener noreferrer" className="group flex items-center gap-5">
              <span className="flex h-12 w-12 items-center justify-center border border-gold/25 transition-colors duration-300 group-hover:border-gold group-hover:bg-gold/10">
                <Instagram className="h-5 w-5 text-gold" strokeWidth={1.25} />
              </span>
              <span>
                <span className="block text-[10px] uppercase tracking-[0.3em] text-white/40">Instagram</span>
                <span className="text-lg text-white transition-colors group-hover:text-gold">{INSTAGRAM}</span>
              </span>
            </a>
          </Reveal>
          <Reveal delay={0.24}>
            <div className="flex flex-wrap gap-3 pt-4">
              <a data-testid="contact-call-button" href={PHONE_HREF} className="bg-gold px-7 py-3.5 text-xs font-semibold uppercase tracking-[0.2em] text-ink transition-colors duration-300 hover:bg-gold-bright">
                Call Now
              </a>
              <a data-testid="contact-text-button" href={SMS_HREF} className="flex items-center gap-2 border border-gold/50 px-7 py-3.5 text-xs font-semibold uppercase tracking-[0.2em] text-gold transition-colors duration-300 hover:bg-gold/10">
                <MessageSquare className="h-4 w-4" /> Text Us
              </a>
              <a data-testid="contact-directions-button" href={DIRECTIONS_HREF} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 border border-white/15 px-7 py-3.5 text-xs font-semibold uppercase tracking-[0.2em] text-white/80 transition-colors duration-300 hover:border-gold hover:text-gold">
                <Navigation className="h-4 w-4" /> Get Directions
              </a>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.15}>
          <div className="border border-white/10 bg-surface p-8 md:p-10">
            <div className="flex items-center gap-3">
              <MapPin className="h-5 w-5 text-gold" strokeWidth={1.25} />
              <h3 className="font-display text-2xl tracking-tight text-white">Service Areas</h3>
            </div>
            <p className="mt-4 text-sm font-light leading-relaxed text-white/50">
              Based in Miami, Florida — delivering across all of South Florida.
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              {SERVICE_AREAS.map((a) => (
                <span key={a} data-testid={`service-area-${a.toLowerCase().replace(/\s+/g, '-')}`} className="border border-white/10 px-4 py-2 text-xs uppercase tracking-[0.15em] text-white/60 transition-colors duration-300 hover:border-gold/40 hover:text-gold">
                  {a}
                </span>
              ))}
            </div>
            <div className="mt-8 border-t border-white/10 pt-6">
              <span className="text-[10px] uppercase tracking-[0.3em] text-white/40">Business Hours</span>
              <p data-testid="contact-hours" className="mt-2 text-sm text-white/70">Monday – Sunday · 8:00 AM – 10:00 PM</p>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default Contact;
